import type { Dispatch, SetStateAction } from 'react';
import { useContext } from 'react';
import { createContext } from 'react';
import { ChatResponseType } from '@trinity/chat';
import { createNamedContext } from '@trinity/chat-components/utils';

type TextToSpeechAudioPlayerRefValue = [HTMLAudioElement | undefined, Dispatch<HTMLAudioElement | undefined>];

type InitiateQuerySpeechToText = (data: Omit<TextToSpeechState, 'state'>) => unknown;
export type TextToSpeechAudioMetadata = {
  kolSearchId: number | null;
  queryId: number | null;
  loadingState: 'loading' | 'loaded' | 'error' | null;
};
export type TextToSpeechState = {
  kolSearchId: number | null;
  queryId: number | null;
  state: 'playing' | 'paused' | 'loading' | 'error' | 'stopped';
};

export type VoiceModeContextValue = {
  dequeue: () => void;
  enabled: boolean;
  enable: () => void;
  disable: () => void;
  enqueue: (data: { queryId: number; type: ChatResponseType }) => void;
  queryId: number;
  type: ChatResponseType;
  toggle: () => void;
};

export type MicState = 'inactive' | 'waiting-for-permission' | 'listening' | 'error';

export type MicrophoneStateContextValue = [MicState, Dispatch<SetStateAction<MicState>>];

export const TextToSpeechAudioPlayerRefContext = createNamedContext<TextToSpeechAudioPlayerRefValue>(
  undefined,
  'TextToSpeechAudioPlayer.Context',
);

export type AudioContextValue = {
  onPlay: (audioUrl: string) => void;
  onStop: () => void;
  src: string | null;
};

type StopTextToSpeechContextValue = (isNavigationAction?: boolean) => void;

export const OnTextToSpeechAudioReadyContext = createNamedContext<(audioUrl: string) => void>(null, 'OnTextToSpeechAudioReady');
export const InitiateQuerySpeechToText = createNamedContext<InitiateQuerySpeechToText>(null, 'InitiateQuerySpeechToText');
export const TextToSpeechStateContext = createNamedContext<TextToSpeechState>(null, 'TextToSpeechState');
export const StopTextToSpeechContext = createNamedContext<StopTextToSpeechContextValue>(null, 'StopTextToSpeech');
export const VoiceModeContext = createNamedContext<VoiceModeContextValue>(undefined, 'VoiceMode.Context');
export const MicrophoneStateContext = createNamedContext<MicrophoneStateContextValue>(undefined, 'MicrophoneState.Context');
export const useTextToSpeechAudioPlayerRef = () => useContext(TextToSpeechAudioPlayerRefContext);
export const LoadingVoiceClipContext = createContext<AudioContextValue>(null);